var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user-avatar" }, [
    _vm.url
      ? _c("img", {
          attrs: { src: _vm.url, alt: _vm.name },
          on: { error: _vm.clear },
        })
      : _c("span", [_vm._v(_vm._s((_vm.name || "?").slice(-2)))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }